import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onReplaceLinkClick } from 'ctm-util-functions';
import { splitTrafficIdSelector } from 'ctm-selectors';
import { getLabelFromCode, getColourLabel } from '../../core/state_selectors';
import { CarBrandIcon } from '../car_brand_icon/car_brand_icon';
import styles from './car_details_for_rego_motorweb.css';

/**
 * Render the Car Details component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const _CarDetailsForRegoAndMotorWeb = ({ make, model, year, body, transmission, fuel, description, splitTrafficId }) => {
    const handleOnReplaceLinkClick = (event) => onReplaceLinkClick(event, '/car-insurance/journey/edit_car_details');
    return (
        <div className={styles.root}>
            <p>{description}</p>
            <a data-id="edit_car_details_link" href="#" className={styles.detailsLink} onClick={handleOnReplaceLinkClick}>
                Click here
            </a>
            <span> if this doesn't look right...</span>
        </div>
    );
};

_CarDetailsForRegoAndMotorWeb.propTypes = {
    make: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    transmission: PropTypes.string.isRequired,
    fuel: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state) => {
    const splitTrafficId = splitTrafficIdSelector(state);

    return {
        badge: getLabelFromCode(state, 'coverDetail.vehicle.badge', 'vertical.quote.apiResponses.badge'),
        make: getLabelFromCode(state, 'coverDetail.vehicle.make', 'vertical.quote.apiResponses.makes'),
        year: getLabelFromCode(state, 'coverDetail.vehicle.year', 'vertical.quote.apiResponses.years'),
        model: getLabelFromCode(state, 'coverDetail.vehicle.model', 'vertical.quote.apiResponses.models'),
        body: getLabelFromCode(state, 'coverDetail.vehicle.body', 'vertical.quote.apiResponses.bodies'),
        transmission: getLabelFromCode(state, 'coverDetail.vehicle.transmission', 'vertical.quote.apiResponses.transmissions'),
        fuel: getLabelFromCode(state, 'coverDetail.vehicle.fuel', 'vertical.quote.apiResponses.fuel'),
        description: state.getIn('vertical.quote.apiResponses.description'.split('.')) || '',
        splitTrafficId
    };
};

const CarDetailsForRegoAndMotorWeb = connect(mapStateToProps)(_CarDetailsForRegoAndMotorWeb);

export { CarDetailsForRegoAndMotorWeb, _CarDetailsForRegoAndMotorWeb };
